import { render, staticRenderFns } from "./install-pwa-banner.vue?vue&type=template&id=4705c341&scoped=true&"
import script from "./install-pwa-banner.vue?vue&type=script&lang=js&"
export * from "./install-pwa-banner.vue?vue&type=script&lang=js&"
import style0 from "./install-pwa-banner.vue?vue&type=style&index=0&id=4705c341&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705c341",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBanner,VBtn,VContainer})
